import React from "react";

import { findTarget, findRel } from "../../../shared/utils/stringUtilities";

import "./cardIcon.scss";

const CardIcon = (props: CardIconInterface) => {
  const { iconSrc, iconAlt, text, link, titleBtn, gtmMark, contenido } = props;

  return (
    <a
      href={link}
      target={findTarget(link)}
      rel={findRel(link)}
      className={`a-card-icon ${gtmMark}`}
    >
      <div className="a-card-icon__icon">
        {iconSrc && (
          <img className={`${gtmMark}`} src={iconSrc} alt={iconAlt} />
        )}
      </div>
      <p className={`a-card-icon__txt ${gtmMark}`}>
        <b>{text}</b>
        <br/>
        <br/>
        {contenido}
      </p>
      <span className={`a-card-icon__more ${gtmMark}`}>{titleBtn}</span>
    </a>
  );
};

interface CardIconInterface {
  iconSrc: string;
  iconAlt: string;
  text: any;
  link: string;
  titleBtn: string;
  gtmMark?: string;
  contenido: string;
}

export default CardIcon;
